import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { SimpleFilter } from '../../models/simple-filter';
import { HttpClient } from '@angular/common/http';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { ManufacturerAuction } from '../../models/manufacturer-auction';

const apiServer = environment.apiServer;
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-home-main-modal-detail-manufacturer',
  templateUrl: './home-main-modal-detail-manufacturer.component.html',
  styleUrls: ['./home-main-modal-detail-manufacturer.component.sass']
})
export class HomeMainModalDetailManufacturerComponent implements OnInit, AfterViewInit {


  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  dt: DataTables.Api;
  modelManufacturerFilter: SimpleFilter = new SimpleFilter();
  modelManufacturerAuction: ManufacturerAuction = new ManufacturerAuction();
  dtOptionsManufacturers: DataTables.Settings = {};
  dataSetManufacturers: any;
  selectedRow: number;

  constructor(private http: HttpClient, private bus: BusAuctionFilterService) { }

  ngOnInit() {

    const that = this;
    this.dtOptionsManufacturers = {
      pagingType: 'full_numbers',
      pageLength: 250,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        dataTablesParameters.Name = this.modelManufacturerFilter.name;

        that.http.post<DataTablesResponse>(`${apiServer}/manufacturer`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetManufacturers = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [
        { orderable: false },
        { data: 'manufactName', name: 'manufactName' },
      ]
    };

  }

  onFieldChange() {
    this.dt.ajax.reload();
  }

  onSelectManufacturer(manufacturer: string): void {
    const item = this.dataSetManufacturers[this.selectedRow];
    this.bus.currentAuction.drugs.filter(c => c.current)[0].manufacturer = item.name;
    let regexp = /^((?!(Гротекс)).)*$/;
    if (item.name != null) {
      if (!regexp.test(item.name))
        this.bus.currentAuction.statusst = 'Выиграли';
      else
        this.bus.currentAuction.statusst = 'Проиграли';
    }
    // this.modelManufacturerAuction.distributerParticipant = distributor;
    $('#modalDetailManufacturer').modal('hide');
  }

  onSelectManufacturerRow(index, manufacturer: string): void {
    this.selectedRow = index;
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }


}


// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail-manufacturer/home-main-modal-detail-manufacturer.component.ts